import { TenantTurnerConnectForm } from './TenantTurnerConnectForm'
import type { VendorConnectorProps } from './types'

export function TenantTurnerConnector({ onConnected }: VendorConnectorProps) {
  return <TenantTurnerConnectForm onConnected={() => onConnected?.()} />
}
